<template>
    <div class="wrapper">
        <p class="guide">
            Step <em>{{ route.query.step }}</em> / {{ route.query.as }}
        </p>
        <h1 class="title">Face Recognition</h1>
        <Upload 
            :needShowList='obj["face"]'
            title= "Face Recognition"
            invoke_type = '5'
            type_txt = 'face'
            @set_value=set_value
        ></Upload>
        <div class="placeholder"></div>
        <div class="btn-container">            
            <a class='btn-submit' @click="submit">CONFIRM TO NEXT</a>
        </div>
    </div>    
</template>
<script>
import Upload from '@/components/business/kyc/upload.vue'
import { ref, onMounted, getCurrentInstance,reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
import { livingHold } from '@api/index'
export default {
    components:{
        Upload
    },
    props:{
        title:{
            type:String
        },
        needShowList:{
            type:Object
        },
        invoke_type:{
            type:String
        },
        type_txt:{
            type:String
        }
    },
    setup() {      
        const $loading = useLoading()
        const clicked = ref(false)
        const router = useRouter()
        const route = router.currentRoute
        const proxy = getCurrentInstance().proxy
        const obj = reactive({
            "face": []        
        })  
        const config = reactive({
            living_type:null
        })      
        onMounted(async () => {
            document.body.style.background = '#F8F8F8'            
            
        })
        const validate = () => {
            let res = true
            if (obj['face'].length == 0) {
                proxy.$toast.show('Please Upload Face Recognition ')
                res =false
                
            }
            
            return res
        }
        const submit = async () => {
            if(!validate()) return
            if(clicked.value)return 
            clicked.value = true
            const loader = $loading.show({
                container: null
            })
            let data = await livingHold()
            loader.hide()
            clicked.value = false
            if(data.code == 0) {
                router.push({
                    "path":"/auth/index",
                    "query":{
                        "pid":route.value.query.pid
                    }
                })                         
            } else {
                proxy.$toast.show(data.msg)
            }
        }

        const set_value = (key, v) => {
            obj[key] = v
        }


        return {
            obj,
            set_value,
            submit,
            validate,
            config,
            route
        }
    }
}
</script>
<style lang="less" scoped>
@import "assets/less/icon.less";
.wrapper{
        padding:40px;
        .guide{
            color:#A59BB3;
            font-size: 30px;
            em{
                color:#BE9060;
            font-weight: 700;
            }
        }
        .title{
            color:#BE9060;
            font-size: 40px;
            margin: 50px 0;  
        }
    }
    .btn-container{
        position: fixed;
        left:0;
        bottom: 0;        
        background:#fff;
        padding:40px;
        // padding:40px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#BE9060;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
        }
    }
    .placeholder{
        height: 176px;        
    }
    .upload-wrapper{
        width: 574px;
        margin:0 auto 50px auto;
        border-radius: 15px;
        background:#fff;
        padding:25px 40px;
        .uw-title{
            font-size: 32px;
            color:#000;
            margin-bottom: 30px;
        }
        .upload-operation{
            .no-img{
                width: 276px;
                height:164px;
                background:#F5F3FF;
                display:flex;
                justify-content: center;
                align-items: center;
                border-radius: 15px;
            }
            .have-img{
                width: 276px;
                height:114px;
                background:#BE9060;
                padding-top: 50px;                                
                border-radius: 15px;
                .img-cap{
                    color:#fff;
                    text-align: center;
                    margin-top: 10px;
                    font-size: 24px;
                }
            }
        }
        .img-info{
            margin-top: 30px;
            .img-info-ele{
                padding:25px 0;
                border-bottom:2px solid #EFEEF1;
                .img-info-title{
                    color:#73698F;
                    font-size: 26px;
                }
                .img-info-content{
                    color:#000;
                    font-size: 30px;
                    margin-top: 30px;
                }
            }
        }
    }
</style>